import { render, staticRenderFns } from "./GameCommander.vue?vue&type=template&id=6bc9ae0e&scoped=true&"
import script from "./GameCommander.vue?vue&type=script&lang=js&"
export * from "./GameCommander.vue?vue&type=script&lang=js&"
import style0 from "./GameCommander.vue?vue&type=style&index=0&id=6bc9ae0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc9ae0e",
  null
  
)

export default component.exports